import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Row } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { isEmpty, orderBy } from "lodash"
import PropTypes from "prop-types"
import Switch from "react-switch";
import moment from "moment"

// redux :: action
import { getallscrutinynotes, getallscrutinynotestype, updateScrutinyStatus } from "store/ScrutinyNotes/action"
import { getUsersList } from "store/userlist/action"
import { setIsMobile } from "store/actions"
import { formateStringofDate } from "helpers/util"

// components 
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "./Table/Table"
import MobileView from "./MobileView"
import Filter from "./filter"

const Index = () => {
  const dispatch = useDispatch()
  // use selector
  const { isMobile, scrutinynoteslist, userList, scrutinynotesTypelist } = useSelector(state => ({
    isMobile: state.teams.isMobile,
    scrutinynoteslist: state?.ScrutinyNote?.getallscrutinynotesSuccess,
    scrutinynotesTypelist: state?.ScrutinyNote?.getallscrutinynotestypeSuccess?.data,
    userList: state?.userlist?.alluserslist?.data || [],
  }))
  const orderedUserLists = orderBy(userList, "username")
  const allUserLists = [{ id: 0, label: "All", value: 0 }].concat(
    orderedUserLists.map(el => ({ ...el, label: el.username, value: el.id }))
  )

  const scrutinynotesTypelistArr = [{ id: 0, label: "All", value: 0 }].concat(
    (scrutinynotesTypelist || []).map(el => ({ ...el, label: el.type, value: el.id }))
  )

  const scrutinynoteslistData = scrutinynoteslist?.scrutinyNotes
  const [handleAccordion, sethandleAccordion] = useState(false)
  const [isSorting, setIsSorting] = useState(false)
  const [statusName, setStatusName] = useState({});


  const [reqParams, setReqParams] = useState({
    startDate: moment(new Date()).toISOString(),
    endDate: moment(new Date()).toISOString(),
    empId: 0,
    scrutinyType: 0
  });

  const [pagination, setPagination] = useState({
    pagesize: 10,
    pagenumber: 1,
    sortKey: "",
    sortValue: ""
  });

  const onHandleFilterBtnClicked = () => {
    loadScreenworkfromhome()
  }

  const loadScreenworkfromhome = () => {
    let reqObj ={
      ...reqParams,
      ...pagination
    }
    dispatch(getallscrutinynotes(reqObj))   // trigger get all scrutiny notes 
  }

  useEffect(() => {
    loadScreenworkfromhome()
  }, [pagination, reqParams?.scrutinyType, reqParams?.empId]);

  const handleSubmit = e => {
    e.preventDefault()
    onHandleFilterBtnClicked()
  }

  useEffect(() => {
    dispatch(getUsersList())
    dispatch(getallscrutinynotestype())
    const handleResize = () => {
      dispatch(setIsMobile(window.innerWidth < 921))
    }
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, []);

  useEffect(() => {
    // Set initial status names based on the data fetched
    if (scrutinynoteslistData) {
      const statusObj = {}
      scrutinynoteslistData?.map((el, index) => {
        statusObj[el?.scrutinyNotesId] = el?.statusName
      })
      setStatusName(statusObj);
    }
  }, [scrutinynoteslistData]);

  const handleActiveUser = data => {
    setReqParams(prev => ({ ...prev, empId: data.id }));
  }

  const handleactivescrutinytypes = (value) => {
    setReqParams(prev => ({ ...prev, scrutinyType: value.id }));
  }

  const handlePageChange = (page) => {
    setPagination(prev => ({ ...prev, pagenumber: page }));
    setIsSorting(false)
  };

  const handlePageSizeChange = (size) => {
    setPagination(prev => ({ ...prev, pagesize: size }));
    setIsSorting(false)
  };

  const handleSortChange = (accessor) => {
    setPagination(prev => ({ ...prev, sortKey: accessor?.id, sortValue: accessor?.sortDirection === "asc" ? "desc" : "asc", pagenumber: 0 }));
    setIsSorting(!isSorting)
  };

  const handleDateChange = (value, type) => {
    let dateObj = { ...reqParams }

    if (type === "start") {
      dateObj = { ...dateObj, startDate: moment(value).toISOString() }
    } else {
      dateObj = { ...dateObj, endDate: moment(value).toISOString() }
    }
    setReqParams(dateObj)
  };

  const handleUpdateScrutinyStatus = (val, selectedRow) => {

    const newStatus = statusName[selectedRow?.row?.original?.scrutinyNotesId] === "Open" ? "Close" : "Open";
    setStatusName(prevState => ({
      ...prevState,
      [selectedRow?.row?.original?.scrutinyNotesId]: newStatus
    }));

    let scrutinyStatusObj = {
      userId: selectedRow?.row?.original?.employeeId,
      date: selectedRow?.row?.original?.scrutinyNotesDate,
      scrutinyType: selectedRow?.row?.original?.scrutinyTypeId,
      status: newStatus === "Close" ? 2 : 1
    }

    dispatch(updateScrutinyStatus(scrutinyStatusObj))
  };

  const columns = React.useMemo(() => {
    const result = [
      {
        Header: "Date",
        accessor: "scrutinyNotesDate",
        disableFilters: true,
        sort: true,
        sortDirection: pagination?.sortKey === "scrutinyNotesDate" ? pagination?.sortValue : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          let formattedDate = moment.parseZone(cellProps?.value).format("YYYY-MM-DD");
          return formattedDate
        },
      },
      {
        Header: "EmpId",
        accessor: "userIdentificationNumber",
        // accessor: "employeeId",
        disableFilters: true,
        sort: true,
        sortDirection: pagination?.sortKey === "userIdentificationNumber" ? pagination?.sortValue : "none",
        style: {
          minWidth: isMobile ? "" : "80px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "80px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "EmpName",
        accessor: "employeeName",
        disableFilters: true,
        sort: true,
        sortDirection: pagination?.sortKey === "employeeName" ? pagination?.sortValue : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "ScrutinyType",
        accessor: "scrutinyTypeName",
        disableFilters: true,
        sort: true,
        sortDirection: pagination?.sortKey === "scrutinyTypeName" ? pagination?.sortValue : "none",
        style: {
          minWidth: isMobile ? "" : "200px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "200px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Description",
        accessor: "description",
        disableFilters: true,
        sort: true,
        sortDirection: pagination?.sortKey === "description" ? pagination?.sortValue : "none",
        Cell: cellProps => {
          const formatedText = formateStringofDate(cellProps?.value)
          return formatedText
        },
        style: {
          minWidth: isMobile ? "" : "300px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "300px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Admin Notes",
        accessor: "adminNotes",
        disableFilters: true,
        sort: true,
        sortDirection: pagination?.sortKey === "adminNotes" ? pagination?.sortValue : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: "start",
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      {
        Header: "Status",
        accessor: "statusName",
        disableFilters: true,
        sort: true,
        sortDirection: pagination?.sortKey === "statusName" ? pagination?.sortValue : "none",
        style: {
          minWidth: isMobile ? "" : "160px",
          textAlign: 'center',
          maxWidth: isMobile ? "" : "160px",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        Cell: cellProps => {
          return (
            !isEmpty(statusName) && <div className="d-flex gap-2 flex-wrap justify-content-start align-items-center direction-row">
              <label>
                <Switch
                  checked={statusName[cellProps?.row?.original?.scrutinyNotesId] === "Open" ? true : false}
                  onChange={(val) => handleUpdateScrutinyStatus(val, cellProps)}
                  checkedIcon={false}
                  uncheckedIcon={false}
                  width={30}
                  height={15}
                  className="d-flex mt-2"
                  onColor='#E69138'
                />
              </label>
              <div >{statusName[cellProps?.row?.original?.scrutinyNotesId]}</div>
            </div>)
        },
      },
    ]
    return result
  }, [isMobile, reqParams, pagination, statusName, scrutinynoteslistData]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={"Scrutiny Notes"}
            breadcrumbItem={"Scrutiny Notes"}
          />

          <Card>
            <CardBody>
              <Filter
                startDate={new Date(reqParams?.startDate)}
                endDate={new Date(reqParams?.endDate)}
                handleDateChange={handleDateChange}
                handleSubmit={handleSubmit}
                allUserLists={allUserLists}
                handleActiveUser={handleActiveUser}
                activeUser={allUserLists.find(user => user.id === reqParams?.empId)}
                scrutinynotesTypelist={scrutinynotesTypelistArr}
                scrutinyType={scrutinynotesTypelistArr.find(el => el.id === reqParams?.scrutinyType)}
                handleactivescrutinytypes={handleactivescrutinytypes}
              />
              <Row>
                <Col xs="12">
                  <div className="p-0">
                    {!isMobile ? (
                      <>
                        <div className="table-mobileView">
                          <TableContainer
                            columns={columns}
                            data={scrutinynoteslistData || []}
                            isMobile={isMobile}
                            isSorting={isSorting}
                            customPageSize={pagination?.pagesize}
                            pageNumber={pagination?.pagenumber}
                            totalCount={scrutinynoteslist?.count || 0}
                            onPageChange={handlePageChange}
                            onPageSizeChange={handlePageSizeChange}
                            onHeaderClick={handleSortChange}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        {scrutinynoteslistData?.map((item, index) => {
                          return (
                            <MobileView
                              key={index}
                              keyId={index}
                              data={item || []}
                              sethandleAccordion={sethandleAccordion}
                              handleAccordion={handleAccordion}
                            />
                          )
                        })}
                      </>
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}
Index.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Index
